// This code was generated by AI.
import { SafeArea, SystemBarsStyle } from '@capacitor-community/safe-area'
import CapacitorService from 'app/lib/services/CapacitorService'
// Docs: https://github.com/capacitor-community/safe-area

const safeArea = async () => {
  if (!CapacitorService.isNative() || !CapacitorService.isPluginAvailable('SafeArea')) {
    return
  }

  try {
    await SafeArea.setSystemBarsStyle({
      style: SystemBarsStyle.Light
    })
  } catch {
    // Swallow errors to avoid breaking web builds or unsupported platforms.
  }
}

export default safeArea
